import { Injectable, Type, inject } from '@angular/core';
import { HisDynamicFieldType } from '../model/formfield';
import { DateComponent } from '../component/input-controls/date.component';
import { CheckboxComponent } from '../component/input-controls/checkbox.component';
import { SelectComponent } from '../component/input-controls/select.component';
import { RadioButtonComponent } from '../component/input-controls/radiobutton.component';
import { PasswordComponent } from '../component/input-controls/password.component';
import { TextAreaComponent } from '../component/input-controls/text-area.component';
import { LabelComponent } from '../component/input-controls/label.component';
import { TextComponent } from '../component/input-controls/text.component';
import { MultiSelectComponent } from '../component/input-controls/multiselect.component';
import { KeytableSelectComponent } from '../component/input-controls/keytableselect.component';
import { KeytableMultiSelectComponent } from '../component/input-controls/keytablemultiselect.component';
import { YesNoSelectComponent } from '../component/input-controls/yesnoselect.component';
import { FieldsetComponent } from '../component/input-controls/fieldset.component';
import { YesNoWithTextAreaComponent } from '../component/input-controls/yesno-with-textarea.component';
import { HisComponentRegistryService } from './his-component-registry.service';
import { ChipsComponent } from '../component/input-controls/chips.component';
import { FloatnumberComponent } from '../component/input-controls/floatnumber.component';

/**
 * The component registry manages the mapping of HisDynamicFieldTypes to Angular components.
 *
 * Non standard components can be added via the <code>register</code> method.
 */
@Injectable({providedIn: 'root'})
export class HisComponentRegistryServiceInitilizer {
    private hisComponentRegistryService = inject(HisComponentRegistryService);


    public registerStandardComponents() {
        this.hisComponentRegistryService.register( HisDynamicFieldType.Text, TextComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.Select, SelectComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.KeytableSelect, KeytableSelectComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.KeytableMultiSelect, KeytableMultiSelectComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.Chips, ChipsComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.YesNoSelect, YesNoSelectComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.MultiSelect, MultiSelectComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.Label, LabelComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.Checkbox, CheckboxComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.Password, PasswordComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.DatePicker, DateComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.TextArea, TextAreaComponent );
        // register radiobutton, but overwrite with select, as it does not quite seem to work!?
        this.hisComponentRegistryService.register( HisDynamicFieldType.RadioButton, RadioButtonComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.RadioButton, SelectComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.Fieldset, FieldsetComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.YesNoWithTextArea, YesNoWithTextAreaComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.DeclarationFieldset, YesNoWithTextAreaComponent );
        this.hisComponentRegistryService.register( HisDynamicFieldType.Floatnumber, FloatnumberComponent );
    }
}
